import { createTracker } from 'usage-tracker';
export const standaloneUsageTracker = createTracker({
  standalone: true
});
export const trackInteraction = properties => {
  standaloneUsageTracker.track('Collab Sidebar', 'Collab Sidebar Interaction', properties);
};
export const trackUsage = properties => {
  standaloneUsageTracker.track('Collab Sidebar', 'Collab Sidebar Usage', properties);
};